import BubbleCommon, { overviewKeywordTips } from '@op/components/BubbleCommon';
import CardCommon from '@op/components/CardCommon';
import useLanguage from '@op/hooks/useLanguage';
import KeywordCard from '@op/pages/Performance/components/TopicKeyword/KeywordCard';
import TopicCard from '@op/pages/Performance/components/TopicKeyword/TopicCard';
import React, { useMemo, useState } from 'react';
import { Col, Row } from 'tea-component';

export default function TopicKeyword({
  filter,
  translateTopic,
}: {
  filter: any;
  translateTopic: (value: string) => string;
}) {
  const { formatMessage } = useLanguage();
  const keywordFilter = useMemo(() => {
    return { ...filter, exclude_hashtag: true };
  }, [filter]);

  const [clickInfo, setClickInfo] = useState({
    dataIndex: null,
    seriesIndex: null,
    seriesName: null,
    name: null,
    except_others: null,
    except_topic: null,
    translationData: null,
  });

  const handleClickInfo = (params: any) => {
    setClickInfo(params);
  };

  return (
    <CardCommon bodyStyle={{ paddingTop: 10 }}>
      <Row style={{ marginTop: 2 }} className="dbo-analysis-card-container">
        <Col span={12} className="dbo-performance-topic-card">
          <TopicCard
            filter={filter}
            curFilter={'total'}
            hasTitleArrow={false}
            translateTopic={translateTopic}
            handleClickInfo={handleClickInfo}
          // downloadFileName={'Keyword & Url Analysis'}
          ></TopicCard>
        </Col>

        <Col span={12} className="dbo-performance-keyword-card">
          <KeywordCard
            filter={keywordFilter}
            curFilter={'total'}
            hasTitleArrow={false}
            chartClickAble={false}
            clickInfo={clickInfo}
            downloadHead=""
            hasKeywordDownPage={true}
            dealwithTimeLineParams={(params: any) => ({
              ...params,
              statistics_field: 'overview',
            })}
            title={
              <BubbleCommon
                showIcon={true}
                tipsMap={overviewKeywordTips}
                placement="top"
              >
                {formatMessage({ id: 'Keyword' })}
              </BubbleCommon>
            }
          ></KeywordCard>
        </Col>
      </Row>
    </CardCommon>
  );
}
